import { foods } from './data';
import type { Food } from './types';

/**
 * Slova s kvacicama u obicna.
 *
 * Namjerno RUCNA tablica, ne `String.normalize('NFD')`: Hermes u mobilnoj
 * aplikaciji ima `normalize` samo kad je Intl ukljucen, a ovaj projekt je vec
 * jednom platio pretpostavku da ono sto radi u Nodeu postoji i ondje
 * (`crypto.getRandomValues`). Sest slova je jeftinije od te ovisnosti.
 */
const KVACICE: Record<string, string> = {
  č: 'c', ć: 'c', ž: 'z', š: 's', đ: 'd',
  Č: 'c', Ć: 'c', Ž: 'z', Š: 's', Đ: 'd',
};

export function bezKvacica(tekst: string): string {
  let out = '';
  for (const znak of tekst) out += KVACICE[znak] ?? znak.toLowerCase();
  return out;
}

/**
 * Pretraga namirnica.
 *
 * Trazi po hrvatskom i engleskom nazivu, bez obzira na kvacice — tko upisuje
 * na telefonu rijetko pise „Češnjak" s kvacicama, a popis koji tada ne nadje
 * nista izgleda kao da namirnice nema.
 *
 * Poredak: prvo ono sto POCINJE upisanim, pa ono sto ga sadrzi. Bez toga „sir"
 * prvo izbaci „Svježi sir" umjesto „Sir", a covjek zakljuci da trazi krivo.
 */
export function searchFoods(upit: string, limit = 20): Food[] {
  const q = bezKvacica(upit.trim());
  if (q.length < 2) return [];

  const pocinje: Food[] = [];
  const sadrzi: Food[] = [];

  for (const food of foods) {
    const hr = bezKvacica(food.hr);
    const en = bezKvacica(food.en);
    if (hr.startsWith(q) || en.startsWith(q)) pocinje.push(food);
    else if (hr.includes(q) || en.includes(q)) sadrzi.push(food);
  }

  return [...pocinje, ...sadrzi].slice(0, limit);
}

export interface Obrok {
  kcal: number;
  proteinG: number;
  carbsG: number;
  fatG: number;
}

/**
 * Koliko namirnica donosi za zadanu tezinu.
 *
 * Zaokruzuje se tek OVDJE, na kraju, a ne po sastojku: pet sastojaka
 * zaokruzenih pojedinacno odstupa od zbroja i dnevni zbroj tiho odluta.
 */
export function forWeight(food: Food, grams: number): Obrok {
  const omjer = grams / 100;
  return {
    kcal: Math.round(food.kcal * omjer),
    proteinG: Math.round(food.proteinG * omjer * 10) / 10,
    carbsG: Math.round(food.carbsG * omjer * 10) / 10,
    fatG: Math.round(food.fatG * omjer * 10) / 10,
  };
}
